/* eslint-disable array-callback-return */
<!--
 * @Autor: GeekMzy
 * @Date: 2021-12-27 16:11:31
 * @LastEditors: GeekMzy
 * @LastEditTime: 2022-04-07 11:45:25
 * @FilePath: \htwlgs-drainage-webv2\src\components\charts\SssjChart.vue
 * @Author: desktop-1llkr2o
-->
<template>
  <div id="sssjchart" style="height: 220px; width: 600px"></div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  data() {
    return {
      Chart: {},
    }
  },
  mounted() {
    this.Chart = echarts.init(document.getElementById('sssjchart'))
    this.Chart.clear()
  },
  methods: {
    drawChartData(chartData, standValues) {
      let markLine
      const markLine2 = []
      if (standValues) {
        markLine = {
          // 标准线
          symbol: 'none',
          symbolSize: 14,
          symbolOffset: [0, [0, -10]],
          silent: true,
          lineStyle: {
            color: '#FFD225',
            width: 2,
          },
          label: {
            color: '#FFD225',
            fontSize: 14,
          },
          data: [
            {
              yAxis: standValues,
              label: {
                // position: 'insideEndBottom',
                formatter: '标准值',
              },
            }, // 最大值水平线或垂直线
          ],
        }
      }
      if (chartData) {
        const datas = chartData
        const xdata = []
        const ydata = []
        if (datas) {
          datas.map((o) => {
            xdata.push(o.dataTime)
            ydata.push(o.value)
            markLine2.push([
              { symbol: 'none', coord: [o.dataTime, o.value] },
              {
                symbol: 'none',
                label: {
                  position: 'middle',
                  offset: [0, 50],
                  formatter: '',
                  fontSize: 14,
                },
                coord: [o.dataTime, 0],
              },
            ])
            return o
          })
        }
        this.Chart.setOption({
          grid: {
            top: 10,
            bottom: 70,
          },
          xAxis: {
            type: 'category',
            axisLabel: {
              rotate: 45,
              color: '#fff',
              fontSize: 10,
            },
            axisLine: {
              lineStyle: {
                width: 2,
                color: '#fff',
              },
            },
            // splitLine: {
            //   show: true,
            //   lineStyle: {
            //     color: "#ccc",
            //   },
            // },
            data: xdata,
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              color: '#fff',
              fontSize: 12,
            },
            axisLine: {
              lineStyle: {
                width: 2,
                color: '#fff',
              },
            },
          },
          series: [
            {
              data: ydata,
              type: 'line',
              symbolSize: 10,
              lineStyle: {
                width: 2,
              },
              markLine: markLine,
            },
            {
              type: 'line',
              markLine: {
                symbol: ['none', 'none'],
                label: {
                  show: false,
                },
                animation: false,
                silent: true,
                data: markLine2,
              },
            },
          ],
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
